import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Weekend Landscape",
    description:
        "This module requires 4 stories minimum. It also support several display differences keyed by the item's Style dropdown in edit dash. Text Over Image, Text Over Image without Headshot, Text Over Image without Byline will all impact the display of this module if selected from the Style dropdown.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/jxjXf8PuK2LWpiLTpgHoXk/The-Weekend-Handoff?node-id=37-1440&m=dev",
        },
    ],
};
